module.exports = __webpack_public_path__ + "static/media/6.dabfd321.jpg";